import React, { useState } from "react";
import {
  Table,
  Badge,
  Input,
  Card,
  CardBody,
  Row,
  Col
} from "reactstrap";

interface Props {
  logs: any[];
}

const getRoleColor = (role: string) => {
  if (role === "Admin") return "danger";
  if (role === "Coordinator") return "primary";
  return "dark";
};

const getActionColor = (action: string) => {
  if (action === "Enquiry Created") return "success";
  if (action === "FollowUp Added") return "warning";
  if (action === "Payment Added") return "danger";
  if (action === "Batch created") return "dark";
  return "info";
};



const ActivityLogTable = ({ logs }: Props) => {

  const [search, setSearch] = useState("");

  const filteredLogs = logs.filter((log) =>
    log.userName?.toLowerCase().includes(search.toLowerCase()) ||
    log.role?.toLowerCase().includes(search.toLowerCase()) ||
    log.actionType?.toLowerCase().includes(search.toLowerCase()) ||
    log.entityName?.toLowerCase().includes(search.toLowerCase())
  );

  const renderJson = (jsonString: string | null) => {
    if (!jsonString) return "-";

    try {
      const obj = JSON.parse(jsonString);

      return (
        <div style={{ fontSize: "13px" }}>
          {Object.entries(obj).map(([key, value]) => (
            <div key={key}>
              <strong>{key}</strong>:{" "}
              {value === null || value === undefined
                ? "-"
                : typeof value === "string" && value.includes("T")
                  ? new Date(value).toLocaleDateString()
                  : String(value)}
            </div>
          ))}
        </div>
      );
    } catch {
      return jsonString;
    }
  };


  return (
    <Card
      className="shadow-sm border-0"
      style={{ borderRadius: "12px" }}
    >
      <CardBody>

        {/* Header */}

        <Row className="mb-3 align-items-center">

          <Col md="6">
            <h5 className="fw-bold mb-0">
              Activity Logs
            </h5>
            <small className="text-muted">
              System activity tracking
            </small>
          </Col>

          <Col md="6">
            <Input
              placeholder="🔍 Search user, action, entity..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="rounded-pill shadow-sm"
            />
          </Col>

        </Row>


        {/* Table */}

        <div style={{ overflowY: "auto" }}>

          <Table hover responsive className="align-middle">

            <thead
              style={{
                background: "#f8f9fa",
                position: "sticky",
                top: 0,
                zIndex: 1
              }}
            >
              <tr>
                <th>Time</th>
                <th>User</th>
                <th>Role</th>
                <th>Action</th>
                <th>Entity</th>
                <th>Old Value</th>
                <th>New Values</th>
              </tr>
            </thead>

            <tbody>

              {filteredLogs.length === 0 ? (
                <tr>
                  <td colSpan={6} className="text-center text-muted py-4">
                    No activity logs found
                  </td>
                </tr>
              ) : (
                filteredLogs.map((log) => (

                  <tr key={log.id}>

                    <td style={{ fontSize: "13px" }}>
                      {new Date(log.createdAt).toLocaleString()}
                    </td>

                    <td className="fw-semibold">
                      {log.userName}
                    </td>

                    <td>
                      <Badge color={getRoleColor(log.role)}>
                        {log.role}
                      </Badge>
                    </td>

                    <td>
                      <Badge color={getActionColor(log.actionType)}>
                        {log.actionType}
                      </Badge>
                    </td>

                    <td>{log.entityName}</td>

                    <td style={{ maxWidth: "350px" }}>
                      {renderJson(log.oldValues)}
                    </td>

                    <td style={{ maxWidth: "350px" }}>
                      {renderJson(log.newValues)}
                    </td>
                  </tr>

                ))
              )}

            </tbody>

          </Table>

        </div>

      </CardBody>
    </Card>
  );
};

export default ActivityLogTable;